import { Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

const AddButton = (props) => <Button startIcon={<AddIcon />} {...props} />;

export default AddButton;
